// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"2a0b2557","413":"fdcf6805","469":"520f32ef","488":"f2879ec9"}[chunkId] + ".chunk.js";
};